import {datadogRum} from '@datadog/browser-rum';
import moment from 'moment';

import {InAppNotification, InAppNotificationStatus} from './InAppNotificationConstants';

// Inbox interactions reported to Datadog RUM. Each is sent as `notifications.<action>` so dashboards
// can select every inbox action with `@action.name:notifications.*`. Read and dismiss status changes
// are also counted server-side by `bnch.notifications.in_app.status_transition` once they commit.
export enum NotificationRumAction {
  OPENED_INBOX = 'opened_inbox',
  CLOSED_INBOX = 'closed_inbox',
  CHANGED_TAB = 'changed_tab',
  CLICKED_LINK = 'clicked_link',
  DISMISSED = 'dismissed',
  MARKED_ALL_READ = 'marked_all_read',
  LOADED_MORE = 'loaded_more',
  CLICKED_SHOW_NEW = 'clicked_show_new',
}

// Keep context to counts, flags, and enums: never send notification titles or bodies.
export type NotificationRumContext = Record<string, string | number | boolean>;

export function addNotificationAction(action: NotificationRumAction, context: NotificationRumContext): void {
  datadogRum.addAction(`notifications.${action}`, context);
}

// Context describing the notification a row action was taken on.
export function getNotificationActionContext(
  notification: InAppNotification | undefined,
  now: number = Date.now()
): NotificationRumContext {
  if (notification == null) {
    return {};
  }
  return {
    wasUnread: notification.status === InAppNotificationStatus.UNREAD,
    notificationAgeSeconds: Math.round((now - moment(notification.lastEventAt).valueOf()) / 1000),
  };
}
